import { bostaHttp } from 'http.js';

export const installApp = (payload) => {
  return bostaHttp.put(
    `/sllr/businesses/feature-configurations/app-store/install`,
    payload
  );
};

export const manageApp = (payload) => {
  return bostaHttp.put(
    `/sllr/businesses/feature-configurations/app-store/manage`,
    payload
  );
};
